/**
 * Free gift reward — auto-adds a $0 gift product to the cart when the paid
 * subtotal reaches the configured threshold, and removes it if the cart drops
 * back below. Fully driven by Theme Settings (window.giftRewardConfig).
 *
 * Notes on this theme:
 * - Cart changes are announced via the pubsub `cartUpdate` event.
 * - On the CART PAGE, the theme reloads the page on a foreign cartUpdate, so
 *   after we change the cart there we reload once (guarded, no loop).
 * - In the DRAWER we just re-publish cartUpdate so the drawer re-renders.
 */
(function () {
  var cfg = window.giftRewardConfig;
  if (!cfg || !cfg.enabled || !cfg.variantId) return;

  var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
  var changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change.js';
  var cartUrl = (window.routes && window.routes.cart_url) || '/cart';

  var busy = false;

  function getCart() {
    return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function hasGift(cart) {
    return cart && cart.items && cart.items.some(function (i) {
      return i.variant_id === cfg.variantId;
    });
  }

  function giftQty(cart) {
    var line = cart && cart.items && cart.items.filter(function (i) {
      return i.variant_id === cfg.variantId;
    })[0];
    return line ? line.quantity : 0;
  }

  function addGift() {
    return fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: cfg.variantId, quantity: 1, properties: { _free_gift: 'true' } }],
      }),
    }).then(getCart);
  }

  // Change by line KEY — changing by bare variant id is unreliable in this store.
  function setGiftQtyByKey(key, qty) {
    return fetch(changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    })
      .then(function (r) { return r.json(); })
      .catch(getCart);
  }

  // `changed` must reflect whether the cart ACTUALLY changed — only then do we
  // reload / re-publish, so a no-op or failed request can never cause a loop.
  function finish(changed) {
    var onCartPage = !!document.querySelector('cart-items');
    if (changed && onCartPage) {
      window.location.reload();
      return; // page is unloading; busy intentionally left set
    }
    busy = false;
    // pubsub helpers are bare globals (from pubsub.js / constants.js), not window props
    if (changed && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gift-reward' });
    }
  }

  function reconcile() {
    if (busy) return;
    busy = true;

    getCart()
      .then(function (cart) {
        var giftLine = null;
        var paid = 0;
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          if (item.variant_id === cfg.variantId) {
            giftLine = item;
          } else {
            paid += item.final_line_price; // in currency subunits (e.g. paise)
          }
        }

        var eligible = paid >= cfg.threshold * 100;

        if (eligible && !giftLine) {
          return addGift().then(function (nc) { finish(hasGift(nc)); });
        }
        if (!eligible && giftLine) {
          return setGiftQtyByKey(giftLine.key, 0).then(function (nc) {
            finish(!hasGift(nc));
          });
        }
        // Keep the gift locked to a single unit
        if (giftLine && giftLine.quantity > 1) {
          return setGiftQtyByKey(giftLine.key, 1).then(function (nc) {
            finish(giftQty(nc) === 1);
          });
        }
        finish(false);
      })
      .catch(function () {
        busy = false;
      });
  }

  // React to cart changes (ignore our own re-publish).
  // subscribe / PUB_SUB_EVENTS are bare globals, not window properties.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'gift-reward') return;
      reconcile();
    });
  }

  // Reconcile once on load (covers direct navigation / reloads)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcile);
  } else {
    reconcile();
  }
})();
